import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";

import { useTrackEvent } from "@/utils/Analytics/Mixpanel/hooks/useTrackEvent";
import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

import { useMutationWithError } from "../../../../../../utils/hooks/useMutationWithError";
import {
  SendPasswordResetEmailInput,
  useSendPasswordResetRequestMutation,
} from "./__generated__/useSendPasswordResetRequestMutation.graphql";

export const useSendPasswordResetRequest = () => {
  const [sendPasswordReset, isSendingReset] =
    useMutationWithError<useSendPasswordResetRequestMutation>(
      SendPasswordResetRequestString
    );
  const { showToast } = useToast();
  const trackEvent = useTrackEvent();
  const requestPasswordReset = (
    input: SendPasswordResetEmailInput,
    onComplete: () => void
  ) => {
    const onCompleted = () => {
      showToast({
        description: t`Password reset request received. Take a gander at your email for that reset link!`,
        semanticStyle: "success",
        toastId: "registration-success",
      });
      onComplete();
      return [];
    };

    sendPasswordReset({
      variables: { input },
      onCompleted: (res) => {
        trackEvent("AuthModal.SendPasswordResetRequest", {
          email: input.email,
        });
        onCompleted();
      },
    });
  };

  return [requestPasswordReset, isSendingReset] as const;
};

export const SendPasswordResetRequestString = graphql`
  mutation useSendPasswordResetRequestMutation(
    $input: SendPasswordResetEmailInput!
  ) {
    responsePayload: sendPasswordResetEmail(input: $input) {
      success
      errors {
        code

        message
        field
      }
    }
  }
`;
